var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWillDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 100.999,
    viewBox: "0 0 101 100.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10769",
    "data-name": "Group 10769",
    transform: "translate(-463.824 -1194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10743",
    "data-name": "Group 10743",
    transform: "translate(125.824 75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10731",
    "data-name": "Group 10731",
    transform: "translate(189.741 -145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Will_documentation_-_Flaticon-3",
    "data-name": "Search results for Will documentation - Flaticon-3",
    transform: "translate(183 1264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10341",
    "data-name": "Path 10341",
    d: "M9,1.669V41.815a.669.669,0,0,0,.669.669H39.11a.669.669,0,0,0,.669-.669V1.669A.669.669,0,0,0,39.11,1H9.669A.669.669,0,0,0,9,1.669Zm1.338.669h28.1V41.146h-28.1Z",
    transform: "translate(-9 -1)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10342",
    "data-name": "Path 10342",
    d: "M19.49,13.667a.669.669,0,0,0,.752-.3l1.434-2.39,1.434,2.39a.669.669,0,0,0,.573.325.68.68,0,0,0,.179-.024.669.669,0,0,0,.49-.645V7H23.015v3.606L22.25,9.332a.7.7,0,0,0-1.147,0l-.765,1.275V7H19v6.022A.669.669,0,0,0,19.49,13.667Z",
    transform: "translate(-12.309 -2.985)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10343",
    "data-name": "Path 10343",
    d: "M29,7h1.338v6.691H29Z",
    transform: "translate(-15.618 -2.985)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10344",
    "data-name": "Path 10344",
    d: "M33.669,13.691h2.676V12.353H34.338V7H33v6.022A.669.669,0,0,0,33.669,13.691Z",
    transform: "translate(-16.942 -2.985)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10345",
    "data-name": "Path 10345",
    d: "M40.669,13.691h2.676V12.353H41.338V7H40v6.022A.669.669,0,0,0,40.669,13.691Z",
    transform: "translate(-19.258 -2.985)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10346",
    "data-name": "Path 10346",
    d: "M19,21H36.4v1.338H19Z",
    transform: "translate(-12.309 -7.618)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10347",
    "data-name": "Path 10347",
    d: "M15,25H37.75v1.338H15Z",
    transform: "translate(-10.985 -8.942)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10348",
    "data-name": "Path 10348",
    d: "M15,29H37.75v1.338H15Z",
    transform: "translate(-10.985 -10.265)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10349",
    "data-name": "Path 10349",
    d: "M15,33H37.75v1.338H15Z",
    transform: "translate(-10.985 -11.589)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10350",
    "data-name": "Path 10350",
    d: "M15,37H35.073v1.338H15Z",
    transform: "translate(-10.985 -12.912)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10351",
    "data-name": "Path 10351",
    d: "M47,37h1.338v1.338H47Z",
    transform: "translate(-21.574 -12.912)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10352",
    "data-name": "Path 10352",
    d: "M24.368,46.738v-1.73a.669.669,0,0,0-.669-.669h-1.73L20.826,43.2a.669.669,0,0,0-.946,0l-1.142,1.142h-1.73a.669.669,0,0,0-.669.669v1.73L15.2,47.88a.669.669,0,0,0,0,.946l1.142,1.142V51.7a.669.669,0,0,0,.669.669h1.73L19.88,53.51a.669.669,0,0,0,.946,0l1.142-1.142H23.7a.669.669,0,0,0,.669-.669v-1.73l1.142-1.142a.669.669,0,0,0,0-.946Zm-1.142,2.48a.669.669,0,0,0-.2.473v1.338H21.691a.669.669,0,0,0-.473.2l-.865.865-.865-.865a.669.669,0,0,0-.473-.2H17.676V49.691a.669.669,0,0,0-.2-.473l-.865-.865.865-.865a.669.669,0,0,0,.2-.473V45.676h1.338a.669.669,0,0,0,.473-.2l.865-.865.865.865a.669.669,0,0,0,.473.2h1.338v1.338a.669.669,0,0,0,.2.473l.865.865Z",
    transform: "translate(-10.985 -14.898)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10353",
    "data-name": "Path 10353",
    d: "M22.007,48a2.007,2.007,0,1,0,2.007,2.007A2.007,2.007,0,0,0,22.007,48Zm0,2.676a.669.669,0,1,1,.669-.669A.669.669,0,0,1,22.007,50.676Z",
    transform: "translate(-12.64 -16.552)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10354",
    "data-name": "Path 10354",
    d: "M37,57h8.029v1.338H37Z",
    transform: "translate(-18.265 -19.53)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10355",
    "data-name": "Path 10355",
    d: "M42.717,48.805l-.1.4a.618.618,0,0,1-1.2,0l-.425-1.7a.669.669,0,0,0-1.248-.137l-.739,1.481a1.488,1.488,0,0,1-1.338.827H37v1.338h.669a2.818,2.818,0,0,0,2.465-1.435,1.955,1.955,0,0,0,3.781-.047l.1-.4a1.044,1.044,0,0,1,1.014-.794V47A2.379,2.379,0,0,0,42.717,48.805Z",
    transform: "translate(-18.265 -16.22)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10358",
    "data-name": "Path 10358",
    d: "M20.517,62.033A18.517,18.517,0,1,0,2,43.517,18.539,18.539,0,0,0,20.517,62.033Zm0-33.667a15.15,15.15,0,1,1-15.15,15.15A15.168,15.168,0,0,1,20.517,28.367Z",
    transform: "translate(336 1132.717)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10359",
    "data-name": "Path 10359",
    d: "M77.033,43.517A18.517,18.517,0,1,0,58.517,62.033,18.539,18.539,0,0,0,77.033,43.517Zm-33.667,0a15.15,15.15,0,1,1,15.15,15.15A15.168,15.168,0,0,1,43.367,43.517Z",
    transform: "translate(361.967 1132.717)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10729",
    "data-name": "Group 10729",
    transform: "translate(375.978 1186.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Frame_-_Flaticon-2",
    "data-name": "Search results for Frame - Flaticon-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_005---Rectangle-Frame",
    "data-name": "005---Rectangle-Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M9.519,41.667H30.787a1.525,1.525,0,0,0,1.519-1.53V9.53A1.525,1.525,0,0,0,30.787,8H9.519A1.525,1.525,0,0,0,8,9.53V40.137A1.525,1.525,0,0,0,9.519,41.667Zm0-32.137H30.787V40.137H9.519Z",
    transform: "translate(-8 -8)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M17.537,12.227,12.22,17.583a.767.767,0,0,0,.335,1.291.756.756,0,0,0,.739-.209l5.317-5.356a.769.769,0,0,0-.009-1.073.756.756,0,0,0-1.065-.009Z",
    transform: "translate(-11.237 -11.238)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10728",
    "data-name": "Group 10728",
    transform: "translate(6.157 7.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10727",
    "data-name": "Group 10727",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Couple_-_Free_people_icons-2",
    "data-name": "Couple - Free people icons-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_65",
    "data-name": "Subtraction 65",
    d: "M2.532,19.9a.319.319,0,0,1-.312-.325V13.664a1.232,1.232,0,0,0-.342-.859l-1.249-1.3c0,.019,0,.041,0,.071V19.57a.32.32,0,0,1-.313.325A.319.319,0,0,1,0,19.57V11.577a1.465,1.465,0,0,1,1.014-1.418L3.14,9.5l.222-.463a.31.31,0,0,1,.279-.179.3.3,0,0,1,.088.013V8.784A3.822,3.822,0,0,1,2.229,6a1.092,1.092,0,0,1-.776-.871,1.143,1.143,0,0,1,.135-.741A1.293,1.293,0,0,1,.925,3.243a1.306,1.306,0,0,1,.585-1.089,1.132,1.132,0,0,1-.03-.258A1.075,1.075,0,0,1,2.532.8a1.015,1.015,0,0,1,.394.079A3.192,3.192,0,0,1,5.121,0H6.6A3.186,3.186,0,0,1,8.8.881,1.016,1.016,0,0,1,9.19.8,1.075,1.075,0,0,1,10.242,1.9a1.167,1.167,0,0,1-.029.258,1.309,1.309,0,0,1-.081,2.23,1.142,1.142,0,0,1,.136.74A1.092,1.092,0,0,1,9.493,6a3.826,3.826,0,0,1-1.5,2.791v.08a.3.3,0,0,1,.092-.014.309.309,0,0,1,.279.179l.223.464,2.047.646a.328.328,0,0,1,.208.406.312.312,0,0,1-.3.231.3.3,0,0,1-.091-.014l-1.324-.418a8.565,8.565,0,0,1-3.089,4.03.3.3,0,0,1-.347,0A8.59,8.59,0,0,1,2.6,10.342l-1.408.44a.8.8,0,0,0-.25.132l1.377,1.432a1.892,1.892,0,0,1,.525,1.319V19.57A.32.32,0,0,1,2.532,19.9Zm.857-9.274h0a8.1,8.1,0,0,0,2.473,3.09,8.06,8.06,0,0,0,2.475-3.094l-.823,1.071a.671.671,0,0,1-.533.267H6.969a.67.67,0,0,1-.535-.284l-.261-.362v1.334a.313.313,0,1,1-.625,0V11.308l-.261.362a.67.67,0,0,1-.535.284H4.741a.668.668,0,0,1-.532-.267Zm.392-1.007h0l-.1.206a.332.332,0,0,1-.033.1L4.7,11.281a.05.05,0,0,0,.041.023h0a.055.055,0,0,0,.045-.024l.6-.83-1.6-.835Zm4.159,0-1.6.835.6.83a.056.056,0,0,0,.091,0L8.081,9.907Zm-3.585-.45v.022l1.506.783,1.5-.781V9.165a3.509,3.509,0,0,1-3.007,0ZM5.121.65a2.581,2.581,0,0,0-1.707.65A1.124,1.124,0,0,1,3.27,2.675a1.324,1.324,0,0,1,.129.569A1.286,1.286,0,0,1,2.433,4.5L2.4,4.511a.443.443,0,0,0-.326.51.457.457,0,0,0,.461.367.32.32,0,0,1,.313.325A3.083,3.083,0,0,0,5.861,8.853,3.083,3.083,0,0,0,8.877,5.714a.32.32,0,0,1,.312-.326.457.457,0,0,0,.461-.367.443.443,0,0,0-.3-.5l-.03-.011a1.276,1.276,0,0,1-1-1.263,1.323,1.323,0,0,1,.129-.569A1.124,1.124,0,0,1,8.308,1.3,2.547,2.547,0,0,0,6.6.65Zm4.069.8a.437.437,0,0,0-.427.445.447.447,0,0,0,.25.4.325.325,0,0,1,.176.231.338.338,0,0,1-.077.284.649.649,0,0,0-.164.429.612.612,0,1,0,1.224,0,.634.634,0,0,0-.449-.61.32.32,0,0,1-.209-.2.339.339,0,0,1,.032-.294A.452.452,0,0,0,9.617,1.9.437.437,0,0,0,9.19,1.452Zm-6.658,0A.436.436,0,0,0,2.1,1.9a.451.451,0,0,0,.071.244.339.339,0,0,1,.032.294.318.318,0,0,1-.209.2.634.634,0,0,0-.449.61.626.626,0,0,0,.612.637.626.626,0,0,0,.613-.637.647.647,0,0,0-.164-.429.335.335,0,0,1-.076-.284A.322.322,0,0,1,2.709,2.3a.447.447,0,0,0,.25-.4A.437.437,0,0,0,2.532,1.452Z",
    transform: "translate(0 0)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10722",
    "data-name": "Group 10722",
    transform: "translate(4.808 6.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10721",
    "data-name": "Group 10721",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10375",
    "data-name": "Path 10375",
    d: "M117.365,177.572a.3.3,0,0,0-.44.048.6.6,0,0,1-.994,0,.3.3,0,0,0-.44-.048.334.334,0,0,0-.046.458,1.208,1.208,0,0,0,1.965,0A.334.334,0,0,0,117.365,177.572Z",
    transform: "translate(-115.377 -177.499)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10724",
    "data-name": "Group 10724",
    transform: "translate(4.069 4.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10723",
    "data-name": "Group 10723",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10376",
    "data-name": "Path 10376",
    d: "M97.938,133.124a.319.319,0,0,0-.313.325v.385a.313.313,0,1,0,.625,0v-.385A.319.319,0,0,0,97.938,133.124Z",
    transform: "translate(-97.625 -133.124)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10726",
    "data-name": "Group 10726",
    transform: "translate(7.028 4.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10725",
    "data-name": "Group 10725",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10377",
    "data-name": "Path 10377",
    d: "M168.938,133.124a.319.319,0,0,0-.313.325v.385a.313.313,0,1,0,.625,0v-.385A.319.319,0,0,0,168.938,133.124Z",
    transform: "translate(-168.625 -133.124)",
    fill: "#00641f"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10378",
    "data-name": "Path 10378",
    d: "M10.629,9.754,8.582,10.4l-.223.463a.308.308,0,0,1-.372.165v.081a8.144,8.144,0,0,0-4.258,0v-.082a.308.308,0,0,1-.368-.166L3.139,10.4,1.014,9.736A1.465,1.465,0,0,1,0,8.319V.325A.319.319,0,0,1,.313,0,.319.319,0,0,1,.625.325V8.319c0,.024,0,.047,0,.071l1.249-1.3a1.232,1.232,0,0,0,.342-.859V.325a.313.313,0,1,1,.625,0V6.231a1.891,1.891,0,0,1-.525,1.319L.943,8.982a.791.791,0,0,0,.25.131l1.408.44A8.662,8.662,0,0,1,5.687,5.519a.3.3,0,0,1,.347,0,8.61,8.61,0,0,1,3.089,4.03l1.324-.418a.3.3,0,0,1,.091-.014.314.314,0,0,1,.3.231A.328.328,0,0,1,10.629,9.754Zm-2.548.235L7.024,8.614a.053.053,0,0,0-.046-.022.055.055,0,0,0-.045.024l-.6.83,1.6.835Zm-2.22-.062-1.506.783v.022a3.509,3.509,0,0,1,3.008,0v-.022Zm-2.178.149.1.206,1.6-.835-.6-.83a.055.055,0,0,0-.045-.024.051.051,0,0,0-.046.022L3.649,9.977A.335.335,0,0,1,3.682,10.075Zm2.178-3.89A8.1,8.1,0,0,0,3.388,9.275l.821-1.067a.668.668,0,0,1,.533-.267h.011a.67.67,0,0,1,.535.284l.261.361V7.253a.313.313,0,1,1,.625,0V8.587l.261-.361a.67.67,0,0,1,.535-.284H6.98a.668.668,0,0,1,.533.267l.823,1.071A8.067,8.067,0,0,0,5.861,6.184Z",
    transform: "translate(11.761 19.896) rotate(180)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10740",
    "data-name": "Group 10740",
    transform: "translate(414.265 1164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10733",
    "data-name": "Group 10733",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10732",
    "data-name": "Group 10732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M11.433,22.2V18.015H10.06V22.2a.351.351,0,0,1-.7,0v-6.6a.367.367,0,0,1,.037-.156l.831-1.649a.35.35,0,0,1,.628.312l-.794,1.576v1.63h1.789v-3.68a1.145,1.145,0,0,0-.558-1.006l-.739-.22A4.058,4.058,0,0,1,9.239,14.56,4.1,4.1,0,0,1,2.6,12.412l-1.26.375A.888.888,0,0,0,.7,13.64v3.678H2.49v-1.63L1.7,14.112a.35.35,0,0,1,.627-.312l.83,1.649a.343.343,0,0,1,.037.156v6.6a.351.351,0,0,1-.7,0V18.015H1.117V22.2a.351.351,0,0,1-.7,0V18.015H.351A.349.349,0,0,1,0,17.667V13.64a1.576,1.576,0,0,1,1.137-1.519l3.013-.9V10.209A4.048,4.048,0,0,1,2.5,7.244a1.165,1.165,0,0,1-.426-2.011v-2A3.248,3.248,0,0,1,5.331,0H8.65a1.582,1.582,0,0,1,1.536,1.174,1.992,1.992,0,0,1,.889,1.649V5.233a1.166,1.166,0,0,1-.426,2.011A4.048,4.048,0,0,1,9,10.209v1.013l2.508.748h0a1.687,1.687,0,0,1,1.041,1.669v4.028a.349.349,0,0,1-.35.348h-.065V22.2a.351.351,0,0,1-.7,0ZM3.271,12.211a3.388,3.388,0,0,0,6.607,0l-.921-.274a2.428,2.428,0,0,1-4.763,0Zm1.579-.731v.006a1.724,1.724,0,0,0,3.448,0v-.856a4.1,4.1,0,0,1-3.448,0ZM2.624,5.7,2.6,5.712a.471.471,0,0,0-.241.408.479.479,0,0,0,.48.477.349.349,0,0,1,.35.348,3.384,3.384,0,0,0,6.767,0,.349.349,0,0,1,.35-.348.479.479,0,0,0,.48-.477.468.468,0,0,0-.241-.408.348.348,0,0,1-.174-.3V2.823A1.3,1.3,0,0,0,9.7,1.7a.348.348,0,0,1-.174-.249A.886.886,0,0,0,8.65.7H5.331A2.549,2.549,0,0,0,2.776,3.234V4.95c.021,0,.043,0,.065,0h.53A.066.066,0,0,0,3.433,4.9l.32-.955a.35.35,0,0,1,.332-.239,14.445,14.445,0,0,0,4.823-.787.349.349,0,1,1,.314.623A13.915,13.915,0,0,1,4.339,4.4l-.241.72a.763.763,0,0,1-.726.521h-.53A.483.483,0,0,0,2.624,5.7Z",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10735",
    "data-name": "Group 10735",
    transform: "translate(5.395 7.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10734",
    "data-name": "Group 10734",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10381",
    "data-name": "Path 10381",
    d: "M117.608,182.017a.351.351,0,0,0-.493.051.688.688,0,0,1-1.115,0,.351.351,0,0,0-.545.442,1.388,1.388,0,0,0,2.2,0A.351.351,0,0,0,117.608,182.017Z",
    transform: "translate(-115.377 -181.938)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10737",
    "data-name": "Group 10737",
    transform: "translate(4.565 5.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10736",
    "data-name": "Group 10736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10382",
    "data-name": "Path 10382",
    d: "M97.976,137.562a.351.351,0,0,0-.351.351v.415a.351.351,0,1,0,.7,0v-.415A.351.351,0,0,0,97.976,137.562Z",
    transform: "translate(-97.625 -137.562)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10739",
    "data-name": "Group 10739",
    transform: "translate(7.884 5.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10738",
    "data-name": "Group 10738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10383",
    "data-name": "Path 10383",
    d: "M168.976,137.562a.351.351,0,0,0-.351.351v.415a.351.351,0,1,0,.7,0v-.415A.351.351,0,0,0,168.976,137.562Z",
    transform: "translate(-168.625 -137.562)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10741",
    "data-name": "Group 10741",
    transform: "translate(350.057 1164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10733-2",
    "data-name": "Group 10733",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10732-2",
    "data-name": "Group 10732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5-2",
    "data-name": "Union 5",
    d: "M11.433,22.2V18.015H10.06V22.2a.351.351,0,0,1-.7,0v-6.6a.367.367,0,0,1,.037-.156l.831-1.649a.35.35,0,0,1,.628.312l-.794,1.576v1.63h1.789v-3.68a1.145,1.145,0,0,0-.558-1.006l-.739-.22A4.058,4.058,0,0,1,9.239,14.56,4.1,4.1,0,0,1,2.6,12.412l-1.26.375A.888.888,0,0,0,.7,13.64v3.678H2.49v-1.63L1.7,14.112a.35.35,0,0,1,.627-.312l.83,1.649a.343.343,0,0,1,.037.156v6.6a.351.351,0,0,1-.7,0V18.015H1.117V22.2a.351.351,0,0,1-.7,0V18.015H.351A.349.349,0,0,1,0,17.667V13.64a1.576,1.576,0,0,1,1.137-1.519l3.013-.9V10.209A4.048,4.048,0,0,1,2.5,7.244a1.165,1.165,0,0,1-.426-2.011v-2A3.248,3.248,0,0,1,5.331,0H8.65a1.582,1.582,0,0,1,1.536,1.174,1.992,1.992,0,0,1,.889,1.649V5.233a1.166,1.166,0,0,1-.426,2.011A4.048,4.048,0,0,1,9,10.209v1.013l2.508.748h0a1.687,1.687,0,0,1,1.041,1.669v4.028a.349.349,0,0,1-.35.348h-.065V22.2a.351.351,0,0,1-.7,0ZM3.271,12.211a3.388,3.388,0,0,0,6.607,0l-.921-.274a2.428,2.428,0,0,1-4.763,0Zm1.579-.731v.006a1.724,1.724,0,0,0,3.448,0v-.856a4.1,4.1,0,0,1-3.448,0ZM2.624,5.7,2.6,5.712a.471.471,0,0,0-.241.408.479.479,0,0,0,.48.477.349.349,0,0,1,.35.348,3.384,3.384,0,0,0,6.767,0,.349.349,0,0,1,.35-.348.479.479,0,0,0,.48-.477.468.468,0,0,0-.241-.408.348.348,0,0,1-.174-.3V2.823A1.3,1.3,0,0,0,9.7,1.7a.348.348,0,0,1-.174-.249A.886.886,0,0,0,8.65.7H5.331A2.549,2.549,0,0,0,2.776,3.234V4.95c.021,0,.043,0,.065,0h.53A.066.066,0,0,0,3.433,4.9l.32-.955a.35.35,0,0,1,.332-.239,14.445,14.445,0,0,0,4.823-.787.349.349,0,1,1,.314.623A13.915,13.915,0,0,1,4.339,4.4l-.241.72a.763.763,0,0,1-.726.521h-.53A.483.483,0,0,0,2.624,5.7Z",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10735-2",
    "data-name": "Group 10735",
    transform: "translate(5.395 7.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10734-2",
    "data-name": "Group 10734",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10381-2",
    "data-name": "Path 10381",
    d: "M117.608,182.017a.351.351,0,0,0-.493.051.688.688,0,0,1-1.115,0,.351.351,0,0,0-.545.442,1.388,1.388,0,0,0,2.2,0A.351.351,0,0,0,117.608,182.017Z",
    transform: "translate(-115.377 -181.938)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10737-2",
    "data-name": "Group 10737",
    transform: "translate(4.565 5.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10736-2",
    "data-name": "Group 10736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10382-2",
    "data-name": "Path 10382",
    d: "M97.976,137.562a.351.351,0,0,0-.351.351v.415a.351.351,0,1,0,.7,0v-.415A.351.351,0,0,0,97.976,137.562Z",
    transform: "translate(-97.625 -137.562)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10739-2",
    "data-name": "Group 10739",
    transform: "translate(7.884 5.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10738-2",
    "data-name": "Group 10738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10383-2",
    "data-name": "Path 10383",
    d: "M168.976,137.562a.351.351,0,0,0-.351.351v.415a.351.351,0,1,0,.7,0v-.415A.351.351,0,0,0,168.976,137.562Z",
    transform: "translate(-168.625 -137.562)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow_-_Free_arrows_icons-2",
    "data-name": "Arrow - Free arrows icons-2",
    transform: "translate(350.914 1135.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_40",
    "data-name": "Layer 40",
    transform: "translate(2.07 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10384",
    "data-name": "Path 10384",
    d: "M15.7,6A10.62,10.62,0,0,0,5.094,16.629L2.856,14.392a.471.471,0,0,0-.664.666l3.04,3.04a.471.471,0,0,0,.666,0l3.04-3.04a.471.471,0,0,0-.666-.666L6.035,16.629A9.679,9.679,0,0,1,15.7,6.941.471.471,0,1,0,15.7,6Z",
    transform: "translate(-2.07 -6)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow_-_Free_arrows_icons-2-2",
    "data-name": "Arrow - Free arrows icons-2",
    transform: "translate(352.983 1197.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_40-2",
    "data-name": "Layer 40",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10384-2",
    "data-name": "Path 10384",
    d: "M15.7,18.236A10.62,10.62,0,0,1,5.094,7.606L2.856,9.844a.471.471,0,0,1-.664-.666l3.04-3.04a.471.471,0,0,1,.666,0l3.04,3.04a.471.471,0,1,1-.666.666L6.035,7.606A9.679,9.679,0,0,0,15.7,17.295a.471.471,0,1,1,0,.941Z",
    transform: "translate(-2.07 -6)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow_-_Free_arrows_icons-2-3",
    "data-name": "Arrow - Free arrows icons-2",
    transform: "translate(410.983 1141.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_40-3",
    "data-name": "Layer 40",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10384-3",
    "data-name": "Path 10384",
    d: "M2.54,6A10.62,10.62,0,0,1,13.149,16.63l2.238-2.238a.471.471,0,0,1,.664.666L13.01,18.1a.471.471,0,0,1-.666,0L9.3,15.058a.471.471,0,1,1,.666-.666l2.238,2.238A9.679,9.679,0,0,0,2.54,6.941.471.471,0,1,1,2.54,6Z",
    transform: "translate(-2.07 -6)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow_-_Free_arrows_icons-2-4",
    "data-name": "Arrow - Free arrows icons-2",
    transform: "translate(410.983 1197.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_40-4",
    "data-name": "Layer 40",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10384-4",
    "data-name": "Path 10384",
    d: "M2.54,18.236A10.62,10.62,0,0,0,13.149,7.606l2.238,2.238a.471.471,0,0,0,.664-.666l-3.04-3.04a.471.471,0,0,0-.666,0L9.3,9.178a.471.471,0,0,0,.666.666l2.238-2.238A9.679,9.679,0,0,1,2.54,17.295a.471.471,0,1,0,0,.941Z",
    transform: "translate(-2.07 -6)",
    fill: "#00641f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWillDocument);
export default __webpack_public_path__ + "static/media/willDocument.f9031162e87a67ebb8609efca0b8cbe8.svg";
export { ForwardRef as ReactComponent };